import { Grid, Typography, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

const CardRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: 10,
  border: '1px solid',
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  '&:last-of-type': { marginBottom: 0 },
}))

/**
 * Modern card wrapper for prescription form sub-sections (Header Details, Clinic Details, etc.).
 * Replaces GridSectionWrapper for a consistent, polished look.
 */
export default function PrescriptionSectionCard({
  heading,
  subheading,
  children,
  noHeading = false,
}) {
  return (
    <CardRoot>
      <Grid container spacing={2}>
        {(heading || subheading) && !noHeading && (
          <Grid item xs={12}>
            {heading && (
              <Typography variant="subtitle2" fontWeight={600} color="text.primary" gutterBottom>
                {heading}
              </Typography>
            )}
            {subheading && (
              <Typography variant="caption" color="text.secondary" display="block">
                {subheading}
              </Typography>
            )}
          </Grid>
        )}
        {children}
      </Grid>
    </CardRoot>
  )
}
